import React, {useEffect, useState} from 'react'
import {useCurrentUserId} from '#hooks/store/useCurrentUserId'
import Loading from '#components/a/Loading'
import ManageAbteilungenTagList from './ManageAbteilungenTagList'
import Api from '#services/api'
import actions from 'redux-auto'

export function AbteilungenHeader() {
  const {currentUserId} = useCurrentUserId()
  const [result, setResult] = useState({
    isLoading: true,
    abteilungen: [],
  })

  useEffect(() => {
    loadAbteilungen()
  }, [])

  const loadAbteilungen = async () => {
    try {
      const abteilungen = await Api.getAbteilungenAsFachausbilder()
      setResult({
        isLoading: false,
        abteilungen,
      })
      await actions.authentication.loadInitialUser({id: currentUserId})
    } catch (e) {
      actions.error.writeError({error: e})
      setResult({
        isLoading: false,
        abteilungen: [],
      })
    }
  }

  return (
    <div className="abteilungen-header">
      {result.isLoading ? (
        <Loading />
      ) : (
        ManageAbteilungenTagList({
          currentUserId,
          abteilungen: result.abteilungen,
          refreshAbteilungen: loadAbteilungen,
        })
      )}
    </div>
  )
}

export default AbteilungenHeader
